// TODO: Turn on checking
// @ts-nocheck
import * as React from "react";
import ApiClientModule from "../../../../services/ApiClientModule";

class DynamicControl extends React.Component<any, any> {
  state = {
    data: {},
    loading: true,
    error: "",
  };

  componentDidMount() {
    const apiClientModule = new ApiClientModule();
    const url = "/actualize/public/v1/forms/schema/actualizeRequest/1842/testRefField";

    apiClientModule.getControl(
      url,
      {},
      {
        success: (response) => {
          this.setState({ data: response.data, loading: false });
        },
        error: () => {
          this.setState({ error: "Произошла ошибка", loading: false });
        },
      }
    );
  }

  render() {
    return this.props.children({
      ...this.props,
      ...this.state,
    });
  }
}

export default DynamicControl;
